import React, { useState } from "react";
import Tabs, { Tab } from "common/layouts/Tabs";
import help from "help/viewTCPOptimizationSpeed.md";
import {
  LabelRetrieval,
  FilteringSettings,
  PeriodContext,
} from "../common";
import View from 'common/View';

const speedFacets = ({
  RttiLo = "0-10ms",
  RttiMd = "10-60ms",
  RttiHi = ">60ms",
}) => [
  {
    label: "All Internet Latencies",
    fields: [
      { name: "optimized-global", label: "TCPO", color: "var(--bta-color-strong)" },
      { name: "global", label: "No TCPO", color: "var(--no-bta-color-strong)" },
    ],
    noDataMessage: "Not enough samples",
  },
  {
    label: `${RttiLo} Internet Latency`,
    fields: [
      { name: "optimized-small", label: "TCPO", color: "var(--bta-color-strong)" },
      { name: "small", label: "No TCPO", color: "var(--no-bta-color-strong)" },
    ],
    noDataMessage: "Not enough samples",
  },
  {
    label: `${RttiMd} Internet Latency`,
    fields: [
      { name: "optimized-medium", label: "TCPO", color: "var(--bta-color-strong)" },
      { name: "medium", label: "No TCPO", color: "var(--no-bta-color-strong)" },
    ],
    noDataMessage: "Not enough samples",
  },
  {
    label: `${RttiHi} Internet Latency`,
    fields: [
      { name: "optimized-large", label: "TCPO", color: "var(--bta-color-strong)" },
      { name: "large", label: "No TCPO", color: "var(--no-bta-color-strong)" },
    ],
    noDataMessage: "Not enough samples",
  },
];

export const TCPOComparison = ({ hours = 24 }) => {
  const [params, setParams] = useState({ hours });
  const onHoursChange = (hours) => setParams({ hours });
  return (
    <View title="Average TCP connections speed over time" mdHelp={help}>
          <LabelRetrieval>
            {(labels) => (
              <Tabs>
                <Tab label="DOWNLOAD" id="down" active={true}>
                  <FilteringSettings
                    direction="down"
                    {...params}
                    onHoursChange={onHoursChange}
                  >
                    {(result) => (
                      <PeriodContext facets={speedFacets(labels)} {...result} />
                    )}
                  </FilteringSettings>
                </Tab>
                <Tab label="UPLOAD" id="up">
                  <FilteringSettings
                    direction="up"
                    {...params}
                    onHoursChange={onHoursChange}
                  >
                    {(result) => (
                      <PeriodContext facets={speedFacets(labels)} {...result} />
                    )}
                  </FilteringSettings>
                </Tab>
              </Tabs>
            )}
          </LabelRetrieval>
    </View>
  );
};
